export const LOGIN = 'LOGIN';
export const KEEP_LOGIN = 'KEEP_LOGIN';
export const SIGNUP = 'SIGNUP';
export const LOGOUT = 'LOGOUT';
export const FOLLOW = 'FOLLOW';
export const UNFOLLOW = 'UNFOLLOW';
export const LOADING_ON = 'LOADING_ON';
export const LOADING_OFF = 'LOADING_OFF';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const CHANGE_FULLNAME = 'CHANGE_FULLNAME';
export const CHANGE_PROFILE = 'CHANGE_PROFILE';
export const LIKE = 'LIKE';
export const DISLIKE = 'DISLIKE';
export const ADD_POST = 'ADD_POST';
export const EDIT_POST = 'EDIT_POST';
export const DELETE_POST = 'DELETE_POST';
export const ADD_COMMENT = 'ADD_COMMENT';
export const DELETE_COMMENT = 'DELETE_COMMENT';
